export default __webpack_public_path__ + "static/media/tbm-asset-plank-small.9e487742.svg";